import { render, staticRenderFns } from "./edit-data-parameters.vue?vue&type=template&id=39f4d487&scoped=true&"
import script from "./edit-data-parameters.vue?vue&type=script&lang=ts&"
export * from "./edit-data-parameters.vue?vue&type=script&lang=ts&"
import style0 from "./edit-data-parameters.vue?vue&type=style&index=0&id=39f4d487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f4d487",
  null
  
)

export default component.exports